<div class="modal-header">
  <h5 class="modal-title">
    <i class="fa fa-folder-open me-2"></i>Премести в папка
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <!-- Loading state -->
  <div *ngIf="isLoading" class="text-center py-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Зареждане...</span>
    </div>
    <p class="mt-2 text-muted">Зареждане на папките...</p>
  </div>

  <!-- Error state -->
  <div *ngIf="errorMessage && !isLoading" class="alert alert-danger">
    <i class="fa fa-exclamation-circle me-2"></i>{{ errorMessage }}
  </div>

  <!-- Folder list -->
  <div *ngIf="!isLoading && !errorMessage" class="folder-list">
    <p class="text-muted mb-3">
      Изберете папка за {{ getMessageCountText() }}:
    </p>

    <!-- Inbox option -->
    <div class="folder-item"
         [class.selected]="selectedFolderId === null"
         (click)="selectFolder(null)">
      <div class="folder-icon inbox-icon">
        <i class="fa fa-inbox"></i>
      </div>
      <div class="folder-info">
        <span class="folder-name">Входящи</span>
        <span class="folder-description">Преместване обратно във входящата кутия</span>
      </div>
      <div class="folder-check" *ngIf="selectedFolderId === null">
        <i class="fa fa-check-circle"></i>
      </div>
    </div>

    <hr class="folder-divider" *ngIf="folders.length > 0">

    <!-- Custom folders -->
    <div *ngIf="folders.length === 0 && !isLoading" class="text-center text-muted py-3">
      <i class="fa fa-folder-o fa-2x mb-2"></i>
      <p>Няма създадени папки</p>
    </div>

    <div class="folder-item"
         *ngFor="let folder of folders"
         [class.selected]="selectedFolderId === folder.idMailFolder"
         (click)="selectFolder(folder.idMailFolder)">
      <div class="folder-icon">
        <i class="fa fa-folder"></i>
      </div>
      <div class="folder-info">
        <span class="folder-name">{{ folder.name }}</span>
        <span class="folder-count">{{ folder.messageCount }} съобщения</span>
      </div>
      <div class="folder-check" *ngIf="selectedFolderId === folder.idMailFolder">
        <i class="fa fa-check-circle"></i>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="close()">
    Отказ
  </button>
  <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="isLoading">
    <i class="fa fa-folder-open me-1"></i>Премести
  </button>
</div>
